import {
  useHeading
} from "./YAQX4NUA.js";
import {
  DialogHeadingContext
} from "./LNHZLQEK.js";
import {
  createComponent,
  createElement,
  createHook
} from "./NQJBHION.js";
import {
  useId,
  useSafeLayoutEffect
} from "./J7Q2EO23.js";
import {
  __objRest,
  __spreadValues
} from "./PNRLI7OV.js";

// src/dialog/dialog-heading.ts
import { useContext } from "react";
var useDialogHeading = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const setHeadingId = useContext(DialogHeadingContext);
    const id = useId(props.id);
    useSafeLayoutEffect(() => {
      setHeadingId == null ? void 0 : setHeadingId(id);
      return () => setHeadingId == null ? void 0 : setHeadingId(void 0);
    }, [setHeadingId, id]);
    props = __spreadValues({
      id
    }, props);
    props = useHeading(props);
    return props;
  }
);
var DialogHeading = createComponent((props) => {
  const htmlProps = useDialogHeading(props);
  return createElement("h1", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  DialogHeading.displayName = "DialogHeading";
}

export {
  useDialogHeading,
  DialogHeading
};
